"use strict";

exports.__esModule = true;
exports.SpacingY17Xl = exports.SpacingY16Xl = exports.SpacingY15Xl = exports.SpacingY14Xl = exports.SpacingY13Xl = exports.SpacingY12Xl = exports.SpacingY11Xl = exports.SpacingY10Xl = exports.SpacingY9Xl = exports.SpacingY8Xl = exports.SpacingY7Xl = exports.SpacingY6Xl = exports.SpacingY5Xl = exports.SpacingY4Xl = exports.SpacingY3Xl = exports.SpacingY2Xl = exports.SpacingYXl = exports.SpacingYLg = exports.SpacingYMd = exports.SpacingYSm = exports.SpacingYXs = exports.SpacingX23Xl = exports.SpacingX22Xl = exports.SpacingX21Xl = exports.SpacingX20Xl = exports.SpacingX19Xl = exports.SpacingX18Xl = exports.SpacingX17Xl = exports.SpacingX16Xl = exports.SpacingX15Xl = exports.SpacingX14Xl = exports.SpacingX13Xl = exports.SpacingX12Xl = exports.SpacingX11Xl = exports.SpacingX10Xl = exports.SpacingX9Xl = exports.SpacingX8Xl = exports.SpacingX7Xl = exports.SpacingX6Xl = exports.SpacingX5Xl = exports.SpacingX4Xl = exports.SpacingX3Xl = exports.SpacingX2Xl = exports.SpacingXXl = exports.SpacingXLg = exports.SpacingXMd = exports.SpacingXSm = exports.SpacingXXs = exports.ColorInformational60 = exports.ColorWarning60 = exports.ColorSecondary60 = exports.ColorSecondary40 = exports.ColorSecondary20 = exports.ColorPrimary80 = exports.ColorPrimary60 = exports.ColorPrimary40 = exports.ColorNeutral100 = exports.ColorNeutral90 = exports.ColorNeutral80 = exports.ColorNeutral60 = exports.ColorNeutral40 = exports.ColorNeutral20 = exports.ColorNeutral15 = exports.ColorNeutral10 = exports.ColorNeutral0 = exports.ColorError60 = exports.LineHeight8Xl = exports.LineHeight7Xl = exports.LineHeight6Xl = exports.LineHeight5Xl = exports.LineHeight4Xl = exports.LineHeight3Xl = exports.LineHeight2Xl = exports.LineHeightXl = exports.LineHeightLg = exports.LineHeightMd = exports.LineHeightSm = exports.LineHeightXs = exports.LetterSpacingMd = exports.LetterSpacingSm = exports.LetterSpacingXs = exports.FontWeightLg = exports.FontWeightMd = exports.FontWeightSm = exports.FontWeightXs = exports.FontFamilyBase = exports.FontSizes10Xl = exports.FontSizes9Xl = exports.FontSizes8Xl = exports.FontSizes7Xl = exports.FontSizes6Xl = exports.FontSizes5Xl = exports.FontSizes4Xl = exports.FontSizes3Xl = exports.FontSizes2Xl = exports.FontSizesXl = exports.FontSizesLg = exports.FontSizesMd = exports.FontSizesSm = exports.FontSizesXs = void 0;
exports.SpacingLeft9Xl = exports.SpacingLeft8Xl = exports.SpacingLeft7Xl = exports.SpacingLeft6Xl = exports.SpacingLeft5Xl = exports.SpacingLeft4Xl = exports.SpacingLeft3Xl = exports.SpacingLeft2Xl = exports.SpacingLeftXl = exports.SpacingLeftLg = exports.SpacingLeftMd = exports.SpacingLeftSm = exports.SpacingLeftXs = exports.SpacingTop23Xl = exports.SpacingTop22Xl = exports.SpacingTop21Xl = exports.SpacingTop20Xl = exports.SpacingTop19Xl = exports.SpacingTop18Xl = exports.SpacingTop17Xl = exports.SpacingTop16Xl = exports.SpacingTop15Xl = exports.SpacingTop14Xl = exports.SpacingTop13Xl = exports.SpacingTop12Xl = exports.SpacingTop11Xl = exports.SpacingTop10Xl = exports.SpacingTop9Xl = exports.SpacingTop8Xl = exports.SpacingTop7Xl = exports.SpacingTop6Xl = exports.SpacingTop5Xl = exports.SpacingTop4Xl = exports.SpacingTop3Xl = exports.SpacingTop2Xl = exports.SpacingTopXl = exports.SpacingTopLg = exports.SpacingTopMd = exports.SpacingTopSm = exports.SpacingTopXs = exports.SpacingRight23Xl = exports.SpacingRight22Xl = exports.SpacingRight21Xl = exports.SpacingRight20Xl = exports.SpacingRight19Xl = exports.SpacingRight18Xl = exports.SpacingRight17Xl = exports.SpacingRight16Xl = exports.SpacingRight15Xl = exports.SpacingRight14Xl = exports.SpacingRight13Xl = exports.SpacingRight12Xl = exports.SpacingRight11Xl = exports.SpacingRight10Xl = exports.SpacingRight9Xl = exports.SpacingRight8Xl = exports.SpacingRight7Xl = exports.SpacingRight6Xl = exports.SpacingRight5Xl = exports.SpacingRight4Xl = exports.SpacingRight3Xl = exports.SpacingRight2Xl = exports.SpacingRightXl = exports.SpacingRightLg = exports.SpacingRightMd = exports.SpacingRightSm = exports.SpacingRightXs = exports.SpacingBottom23Xl = exports.SpacingBottom22Xl = exports.SpacingBottom21Xl = exports.SpacingBottom20Xl = exports.SpacingBottom19Xl = exports.SpacingBottom18Xl = exports.SpacingBottom17Xl = exports.SpacingBottom16Xl = exports.SpacingBottom15Xl = exports.SpacingBottom14Xl = exports.SpacingBottom13Xl = exports.SpacingBottom12Xl = exports.SpacingBottom11Xl = exports.SpacingBottom10Xl = exports.SpacingBottom9Xl = exports.SpacingBottom8Xl = exports.SpacingBottom7Xl = exports.SpacingBottom6Xl = exports.SpacingBottom5Xl = exports.SpacingBottom4Xl = exports.SpacingBottom3Xl = exports.SpacingBottom2Xl = exports.SpacingBottomXl = exports.SpacingBottomLg = exports.SpacingBottomMd = exports.SpacingBottomSm = exports.SpacingBottomXs = exports.SpacingY23Xl = exports.SpacingY22Xl = exports.SpacingY21Xl = exports.SpacingY20Xl = exports.SpacingY19Xl = exports.SpacingY18Xl = void 0;
exports.ShadowLg = exports.ShadowMd = exports.ShadowSm = exports.ShadowXs = exports.StrokeLg = exports.StrokeMd = exports.StrokeSm = exports.StrokeXs = exports.Opacity3Xl = exports.Opacity2Xl = exports.OpacityXl = exports.OpacityLg = exports.OpacityMd = exports.OpacitySm = exports.OpacityXs = exports.MotionXl = exports.MotionLg = exports.MotionMd = exports.MotionSm = exports.MotionXs = exports.RadiusRound = exports.RadiusPill = exports.Radius8Xl = exports.Radius7Xl = exports.Radius6Xl = exports.Radius5Xl = exports.Radius4Xl = exports.Radius3Xl = exports.Radius2Xl = exports.RadiusXl = exports.RadiusLg = exports.RadiusMd = exports.RadiusSm = exports.RadiusXs = exports.SpacingLeft23Xl = exports.SpacingLeft22Xl = exports.SpacingLeft21Xl = exports.SpacingLeft20Xl = exports.SpacingLeft19Xl = exports.SpacingLeft18Xl = exports.SpacingLeft17Xl = exports.SpacingLeft16Xl = exports.SpacingLeft15Xl = exports.SpacingLeft14Xl = exports.SpacingLeft13Xl = exports.SpacingLeft12Xl = exports.SpacingLeft11Xl = exports.SpacingLeft10Xl = void 0;
/*
  * Do not edit directly
  * Generated on Wed Apr 14 2021 15:45:03 GMT-0300 (GMT-03:00)
*/

/*
  * Foundation
*/

var FontSizesXs = '12px';
exports.FontSizesXs = FontSizesXs;
var FontSizesSm = '14px';
exports.FontSizesSm = FontSizesSm;
var FontSizesMd = '16px';
exports.FontSizesMd = FontSizesMd;
var FontSizesLg = '18px';
exports.FontSizesLg = FontSizesLg;
var FontSizesXl = '20px';
exports.FontSizesXl = FontSizesXl;
var FontSizes2Xl = '22px';
exports.FontSizes2Xl = FontSizes2Xl;
var FontSizes3Xl = '24px';
exports.FontSizes3Xl = FontSizes3Xl;
var FontSizes4Xl = '28px';
exports.FontSizes4Xl = FontSizes4Xl;
var FontSizes5Xl = '32px';
exports.FontSizes5Xl = FontSizes5Xl;
var FontSizes6Xl = '40px';
exports.FontSizes6Xl = FontSizes6Xl;
var FontSizes7Xl = '48px';
exports.FontSizes7Xl = FontSizes7Xl;
var FontSizes8Xl = '56px';
exports.FontSizes8Xl = FontSizes8Xl;
var FontSizes9Xl = '64px';
exports.FontSizes9Xl = FontSizes9Xl;
var FontSizes10Xl = '72px';
exports.FontSizes10Xl = FontSizes10Xl;
var FontFamilyBase = 'Helvetica Now Display';
exports.FontFamilyBase = FontFamilyBase;
var FontWeightXs = 300;
exports.FontWeightXs = FontWeightXs;
var FontWeightSm = 400;
exports.FontWeightSm = FontWeightSm;
var FontWeightMd = 500;
exports.FontWeightMd = FontWeightMd;
var FontWeightLg = 700;
exports.FontWeightLg = FontWeightLg;
var LetterSpacingXs = '0.3';
exports.LetterSpacingXs = LetterSpacingXs;
var LetterSpacingSm = '0.5';
exports.LetterSpacingSm = LetterSpacingSm;
var LetterSpacingMd = '1.5';
exports.LetterSpacingMd = LetterSpacingMd;
var LineHeightXs = '16px';
exports.LineHeightXs = LineHeightXs;
var LineHeightSm = '20px';
exports.LineHeightSm = LineHeightSm;
var LineHeightMd = '24px';
exports.LineHeightMd = LineHeightMd;
var LineHeightLg = '26px';
exports.LineHeightLg = LineHeightLg;
var LineHeightXl = '28px';
exports.LineHeightXl = LineHeightXl;
var LineHeight2Xl = '32px';
exports.LineHeight2Xl = LineHeight2Xl;
var LineHeight3Xl = '36px';
exports.LineHeight3Xl = LineHeight3Xl;
var LineHeight4Xl = '40px';
exports.LineHeight4Xl = LineHeight4Xl;
var LineHeight5Xl = '52px';
exports.LineHeight5Xl = LineHeight5Xl;
var LineHeight6Xl = '64px';
exports.LineHeight6Xl = LineHeight6Xl;
var LineHeight7Xl = '72px';
exports.LineHeight7Xl = LineHeight7Xl;
var LineHeight8Xl = '96px';
exports.LineHeight8Xl = LineHeight8Xl;
var ColorError60 = '#de1212';
exports.ColorError60 = ColorError60;
var ColorNeutral0 = '#ffffff';
exports.ColorNeutral0 = ColorNeutral0;
var ColorNeutral10 = '#edf0ef';
exports.ColorNeutral10 = ColorNeutral10;
var ColorNeutral15 = '#dbe1dd';
exports.ColorNeutral15 = ColorNeutral15;
var ColorNeutral20 = '#c7cec9';
exports.ColorNeutral20 = ColorNeutral20;
var ColorNeutral40 = '#a5aea7';
exports.ColorNeutral40 = ColorNeutral40;
var ColorNeutral60 = '#6f7974';
exports.ColorNeutral60 = ColorNeutral60;
var ColorNeutral80 = '#596b64';
exports.ColorNeutral80 = ColorNeutral80;
var ColorNeutral90 = '#1f2d27';
exports.ColorNeutral90 = ColorNeutral90;
var ColorNeutral100 = '#000000';
exports.ColorNeutral100 = ColorNeutral100;
var ColorPrimary40 = '#49e295';
exports.ColorPrimary40 = ColorPrimary40;
var ColorPrimary60 = '#11bb77';
exports.ColorPrimary60 = ColorPrimary60;
var ColorPrimary80 = '#0f7c50';
exports.ColorPrimary80 = ColorPrimary80;
var ColorSecondary20 = '#97daff';
exports.ColorSecondary20 = ColorSecondary20;
var ColorSecondary40 = '#1b75dd';
exports.ColorSecondary40 = ColorSecondary40;
var ColorSecondary60 = '#2159a2';
exports.ColorSecondary60 = ColorSecondary60;
var ColorWarning60 = '#b46100';
exports.ColorWarning60 = ColorWarning60;
var ColorInformational60 = '#3d9c96';
exports.ColorInformational60 = ColorInformational60;
var SpacingXXs = '2px';
exports.SpacingXXs = SpacingXXs;
var SpacingXSm = '4px';
exports.SpacingXSm = SpacingXSm;
var SpacingXMd = '8px';
exports.SpacingXMd = SpacingXMd;
var SpacingXLg = '10px';
exports.SpacingXLg = SpacingXLg;
var SpacingXXl = '12px';
exports.SpacingXXl = SpacingXXl;
var SpacingX2Xl = '14px';
exports.SpacingX2Xl = SpacingX2Xl;
var SpacingX3Xl = '16px';
exports.SpacingX3Xl = SpacingX3Xl;
var SpacingX4Xl = '18px';
exports.SpacingX4Xl = SpacingX4Xl;
var SpacingX5Xl = '20px';
exports.SpacingX5Xl = SpacingX5Xl;
var SpacingX6Xl = '24px';
exports.SpacingX6Xl = SpacingX6Xl;
var SpacingX7Xl = '28px';
exports.SpacingX7Xl = SpacingX7Xl;
var SpacingX8Xl = '32px';
exports.SpacingX8Xl = SpacingX8Xl;
var SpacingX9Xl = '36px';
exports.SpacingX9Xl = SpacingX9Xl;
var SpacingX10Xl = '40px';
exports.SpacingX10Xl = SpacingX10Xl;
var SpacingX11Xl = '44px';
exports.SpacingX11Xl = SpacingX11Xl;
var SpacingX12Xl = '48px';
exports.SpacingX12Xl = SpacingX12Xl;
var SpacingX13Xl = '52px';
exports.SpacingX13Xl = SpacingX13Xl;
var SpacingX14Xl = '56px';
exports.SpacingX14Xl = SpacingX14Xl;
var SpacingX15Xl = '60px';
exports.SpacingX15Xl = SpacingX15Xl;
var SpacingX16Xl = '64px';
exports.SpacingX16Xl = SpacingX16Xl;
var SpacingX17Xl = '68px';
exports.SpacingX17Xl = SpacingX17Xl;
var SpacingX18Xl = '72px';
exports.SpacingX18Xl = SpacingX18Xl;
var SpacingX19Xl = '76px';
exports.SpacingX19Xl = SpacingX19Xl;
var SpacingX20Xl = '80px';
exports.SpacingX20Xl = SpacingX20Xl;
var SpacingX21Xl = '96px';
exports.SpacingX21Xl = SpacingX21Xl;
var SpacingX22Xl = '128px';
exports.SpacingX22Xl = SpacingX22Xl;
var SpacingX23Xl = '160px';
exports.SpacingX23Xl = SpacingX23Xl;
var SpacingYXs = '2px';
exports.SpacingYXs = SpacingYXs;
var SpacingYSm = '4px';
exports.SpacingYSm = SpacingYSm;
var SpacingYMd = '8px';
exports.SpacingYMd = SpacingYMd;
var SpacingYLg = '10px';
exports.SpacingYLg = SpacingYLg;
var SpacingYXl = '12px';
exports.SpacingYXl = SpacingYXl;
var SpacingY2Xl = '14px';
exports.SpacingY2Xl = SpacingY2Xl;
var SpacingY3Xl = '16px';
exports.SpacingY3Xl = SpacingY3Xl;
var SpacingY4Xl = '18px';
exports.SpacingY4Xl = SpacingY4Xl;
var SpacingY5Xl = '20px';
exports.SpacingY5Xl = SpacingY5Xl;
var SpacingY6Xl = '24px';
exports.SpacingY6Xl = SpacingY6Xl;
var SpacingY7Xl = '28px';
exports.SpacingY7Xl = SpacingY7Xl;
var SpacingY8Xl = '32px';
exports.SpacingY8Xl = SpacingY8Xl;
var SpacingY9Xl = '36px';
exports.SpacingY9Xl = SpacingY9Xl;
var SpacingY10Xl = '40px';
exports.SpacingY10Xl = SpacingY10Xl;
var SpacingY11Xl = '44px';
exports.SpacingY11Xl = SpacingY11Xl;
var SpacingY12Xl = '48px';
exports.SpacingY12Xl = SpacingY12Xl;
var SpacingY13Xl = '52px';
exports.SpacingY13Xl = SpacingY13Xl;
var SpacingY14Xl = '56px';
exports.SpacingY14Xl = SpacingY14Xl;
var SpacingY15Xl = '60px';
exports.SpacingY15Xl = SpacingY15Xl;
var SpacingY16Xl = '64px';
exports.SpacingY16Xl = SpacingY16Xl;
var SpacingY17Xl = '68px';
exports.SpacingY17Xl = SpacingY17Xl;
var SpacingY18Xl = '72px';
exports.SpacingY18Xl = SpacingY18Xl;
var SpacingY19Xl = '76px';
exports.SpacingY19Xl = SpacingY19Xl;
var SpacingY20Xl = '80px';
exports.SpacingY20Xl = SpacingY20Xl;
var SpacingY21Xl = '96px';
exports.SpacingY21Xl = SpacingY21Xl;
var SpacingY22Xl = '128px';
exports.SpacingY22Xl = SpacingY22Xl;
var SpacingY23Xl = '160px';
exports.SpacingY23Xl = SpacingY23Xl;
var SpacingBottomXs = '2px';
exports.SpacingBottomXs = SpacingBottomXs;
var SpacingBottomSm = '4px';
exports.SpacingBottomSm = SpacingBottomSm;
var SpacingBottomMd = '8px';
exports.SpacingBottomMd = SpacingBottomMd;
var SpacingBottomLg = '10px';
exports.SpacingBottomLg = SpacingBottomLg;
var SpacingBottomXl = '12px';
exports.SpacingBottomXl = SpacingBottomXl;
var SpacingBottom2Xl = '14px';
exports.SpacingBottom2Xl = SpacingBottom2Xl;
var SpacingBottom3Xl = '16px';
exports.SpacingBottom3Xl = SpacingBottom3Xl;
var SpacingBottom4Xl = '18px';
exports.SpacingBottom4Xl = SpacingBottom4Xl;
var SpacingBottom5Xl = '20px';
exports.SpacingBottom5Xl = SpacingBottom5Xl;
var SpacingBottom6Xl = '24px';
exports.SpacingBottom6Xl = SpacingBottom6Xl;
var SpacingBottom7Xl = '28px';
exports.SpacingBottom7Xl = SpacingBottom7Xl;
var SpacingBottom8Xl = '32px';
exports.SpacingBottom8Xl = SpacingBottom8Xl;
var SpacingBottom9Xl = '36px';
exports.SpacingBottom9Xl = SpacingBottom9Xl;
var SpacingBottom10Xl = '40px';
exports.SpacingBottom10Xl = SpacingBottom10Xl;
var SpacingBottom11Xl = '44px';
exports.SpacingBottom11Xl = SpacingBottom11Xl;
var SpacingBottom12Xl = '48px';
exports.SpacingBottom12Xl = SpacingBottom12Xl;
var SpacingBottom13Xl = '52px';
exports.SpacingBottom13Xl = SpacingBottom13Xl;
var SpacingBottom14Xl = '56px';
exports.SpacingBottom14Xl = SpacingBottom14Xl;
var SpacingBottom15Xl = '60px';
exports.SpacingBottom15Xl = SpacingBottom15Xl;
var SpacingBottom16Xl = '64px';
exports.SpacingBottom16Xl = SpacingBottom16Xl;
var SpacingBottom17Xl = '68px';
exports.SpacingBottom17Xl = SpacingBottom17Xl;
var SpacingBottom18Xl = '72px';
exports.SpacingBottom18Xl = SpacingBottom18Xl;
var SpacingBottom19Xl = '76px';
exports.SpacingBottom19Xl = SpacingBottom19Xl;
var SpacingBottom20Xl = '80px';
exports.SpacingBottom20Xl = SpacingBottom20Xl;
var SpacingBottom21Xl = '96px';
exports.SpacingBottom21Xl = SpacingBottom21Xl;
var SpacingBottom22Xl = '128px';
exports.SpacingBottom22Xl = SpacingBottom22Xl;
var SpacingBottom23Xl = '160px';
exports.SpacingBottom23Xl = SpacingBottom23Xl;
var SpacingRightXs = '2px';
exports.SpacingRightXs = SpacingRightXs;
var SpacingRightSm = '4px';
exports.SpacingRightSm = SpacingRightSm;
var SpacingRightMd = '8px';
exports.SpacingRightMd = SpacingRightMd;
var SpacingRightLg = '10px';
exports.SpacingRightLg = SpacingRightLg;
var SpacingRightXl = '12px';
exports.SpacingRightXl = SpacingRightXl;
var SpacingRight2Xl = '14px';
exports.SpacingRight2Xl = SpacingRight2Xl;
var SpacingRight3Xl = '16px';
exports.SpacingRight3Xl = SpacingRight3Xl;
var SpacingRight4Xl = '18px';
exports.SpacingRight4Xl = SpacingRight4Xl;
var SpacingRight5Xl = '20px';
exports.SpacingRight5Xl = SpacingRight5Xl;
var SpacingRight6Xl = '24px';
exports.SpacingRight6Xl = SpacingRight6Xl;
var SpacingRight7Xl = '28px';
exports.SpacingRight7Xl = SpacingRight7Xl;
var SpacingRight8Xl = '32px';
exports.SpacingRight8Xl = SpacingRight8Xl;
var SpacingRight9Xl = '36px';
exports.SpacingRight9Xl = SpacingRight9Xl;
var SpacingRight10Xl = '40px';
exports.SpacingRight10Xl = SpacingRight10Xl;
var SpacingRight11Xl = '44px';
exports.SpacingRight11Xl = SpacingRight11Xl;
var SpacingRight12Xl = '48px';
exports.SpacingRight12Xl = SpacingRight12Xl;
var SpacingRight13Xl = '52px';
exports.SpacingRight13Xl = SpacingRight13Xl;
var SpacingRight14Xl = '56px';
exports.SpacingRight14Xl = SpacingRight14Xl;
var SpacingRight15Xl = '60px';
exports.SpacingRight15Xl = SpacingRight15Xl;
var SpacingRight16Xl = '64px';
exports.SpacingRight16Xl = SpacingRight16Xl;
var SpacingRight17Xl = '68px';
exports.SpacingRight17Xl = SpacingRight17Xl;
var SpacingRight18Xl = '72px';
exports.SpacingRight18Xl = SpacingRight18Xl;
var SpacingRight19Xl = '76px';
exports.SpacingRight19Xl = SpacingRight19Xl;
var SpacingRight20Xl = '80px';
exports.SpacingRight20Xl = SpacingRight20Xl;
var SpacingRight21Xl = '96px';
exports.SpacingRight21Xl = SpacingRight21Xl;
var SpacingRight22Xl = '128px';
exports.SpacingRight22Xl = SpacingRight22Xl;
var SpacingRight23Xl = '160px';
exports.SpacingRight23Xl = SpacingRight23Xl;
var SpacingTopXs = '2px';
exports.SpacingTopXs = SpacingTopXs;
var SpacingTopSm = '4px';
exports.SpacingTopSm = SpacingTopSm;
var SpacingTopMd = '8px';
exports.SpacingTopMd = SpacingTopMd;
var SpacingTopLg = '10px';
exports.SpacingTopLg = SpacingTopLg;
var SpacingTopXl = '12px';
exports.SpacingTopXl = SpacingTopXl;
var SpacingTop2Xl = '14px';
exports.SpacingTop2Xl = SpacingTop2Xl;
var SpacingTop3Xl = '16px';
exports.SpacingTop3Xl = SpacingTop3Xl;
var SpacingTop4Xl = '18px';
exports.SpacingTop4Xl = SpacingTop4Xl;
var SpacingTop5Xl = '20px';
exports.SpacingTop5Xl = SpacingTop5Xl;
var SpacingTop6Xl = '24px';
exports.SpacingTop6Xl = SpacingTop6Xl;
var SpacingTop7Xl = '28px';
exports.SpacingTop7Xl = SpacingTop7Xl;
var SpacingTop8Xl = '32px';
exports.SpacingTop8Xl = SpacingTop8Xl;
var SpacingTop9Xl = '36px';
exports.SpacingTop9Xl = SpacingTop9Xl;
var SpacingTop10Xl = '40px';
exports.SpacingTop10Xl = SpacingTop10Xl;
var SpacingTop11Xl = '44px';
exports.SpacingTop11Xl = SpacingTop11Xl;
var SpacingTop12Xl = '48px';
exports.SpacingTop12Xl = SpacingTop12Xl;
var SpacingTop13Xl = '52px';
exports.SpacingTop13Xl = SpacingTop13Xl;
var SpacingTop14Xl = '56px';
exports.SpacingTop14Xl = SpacingTop14Xl;
var SpacingTop15Xl = '60px';
exports.SpacingTop15Xl = SpacingTop15Xl;
var SpacingTop16Xl = '64px';
exports.SpacingTop16Xl = SpacingTop16Xl;
var SpacingTop17Xl = '68px';
exports.SpacingTop17Xl = SpacingTop17Xl;
var SpacingTop18Xl = '72px';
exports.SpacingTop18Xl = SpacingTop18Xl;
var SpacingTop19Xl = '76px';
exports.SpacingTop19Xl = SpacingTop19Xl;
var SpacingTop20Xl = '80px';
exports.SpacingTop20Xl = SpacingTop20Xl;
var SpacingTop21Xl = '96px';
exports.SpacingTop21Xl = SpacingTop21Xl;
var SpacingTop22Xl = '128px';
exports.SpacingTop22Xl = SpacingTop22Xl;
var SpacingTop23Xl = '160px';
exports.SpacingTop23Xl = SpacingTop23Xl;
var SpacingLeftXs = '2px';
exports.SpacingLeftXs = SpacingLeftXs;
var SpacingLeftSm = '4px';
exports.SpacingLeftSm = SpacingLeftSm;
var SpacingLeftMd = '8px';
exports.SpacingLeftMd = SpacingLeftMd;
var SpacingLeftLg = '10px';
exports.SpacingLeftLg = SpacingLeftLg;
var SpacingLeftXl = '12px';
exports.SpacingLeftXl = SpacingLeftXl;
var SpacingLeft2Xl = '14px';
exports.SpacingLeft2Xl = SpacingLeft2Xl;
var SpacingLeft3Xl = '16px';
exports.SpacingLeft3Xl = SpacingLeft3Xl;
var SpacingLeft4Xl = '18px';
exports.SpacingLeft4Xl = SpacingLeft4Xl;
var SpacingLeft5Xl = '20px';
exports.SpacingLeft5Xl = SpacingLeft5Xl;
var SpacingLeft6Xl = '24px';
exports.SpacingLeft6Xl = SpacingLeft6Xl;
var SpacingLeft7Xl = '28px';
exports.SpacingLeft7Xl = SpacingLeft7Xl;
var SpacingLeft8Xl = '32px';
exports.SpacingLeft8Xl = SpacingLeft8Xl;
var SpacingLeft9Xl = '36px';
exports.SpacingLeft9Xl = SpacingLeft9Xl;
var SpacingLeft10Xl = '40px';
exports.SpacingLeft10Xl = SpacingLeft10Xl;
var SpacingLeft11Xl = '44px';
exports.SpacingLeft11Xl = SpacingLeft11Xl;
var SpacingLeft12Xl = '48px';
exports.SpacingLeft12Xl = SpacingLeft12Xl;
var SpacingLeft13Xl = '52px';
exports.SpacingLeft13Xl = SpacingLeft13Xl;
var SpacingLeft14Xl = '56px';
exports.SpacingLeft14Xl = SpacingLeft14Xl;
var SpacingLeft15Xl = '60px';
exports.SpacingLeft15Xl = SpacingLeft15Xl;
var SpacingLeft16Xl = '64px';
exports.SpacingLeft16Xl = SpacingLeft16Xl;
var SpacingLeft17Xl = '68px';
exports.SpacingLeft17Xl = SpacingLeft17Xl;
var SpacingLeft18Xl = '72px';
exports.SpacingLeft18Xl = SpacingLeft18Xl;
var SpacingLeft19Xl = '76px';
exports.SpacingLeft19Xl = SpacingLeft19Xl;
var SpacingLeft20Xl = '80px';
exports.SpacingLeft20Xl = SpacingLeft20Xl;
var SpacingLeft21Xl = '96px';
exports.SpacingLeft21Xl = SpacingLeft21Xl;
var SpacingLeft22Xl = '128px';
exports.SpacingLeft22Xl = SpacingLeft22Xl;
var SpacingLeft23Xl = '160px';
exports.SpacingLeft23Xl = SpacingLeft23Xl;
var RadiusXs = '2px 2px 2px 2px';
exports.RadiusXs = RadiusXs;
var RadiusSm = '4px 4px 4px 4px';
exports.RadiusSm = RadiusSm;
var RadiusMd = '6px 6px 6px 6px';
exports.RadiusMd = RadiusMd;
var RadiusLg = '8px 8px 8px 8px';
exports.RadiusLg = RadiusLg;
var RadiusXl = '10px 10px 10px 10px';
exports.RadiusXl = RadiusXl;
var Radius2Xl = '12px 12px 12px 12px';
exports.Radius2Xl = Radius2Xl;
var Radius3Xl = '14px 14px 14px 14px';
exports.Radius3Xl = Radius3Xl;
var Radius4Xl = '16px 16px 16px 16px';
exports.Radius4Xl = Radius4Xl;
var Radius5Xl = '18px 18px 18px 18px';
exports.Radius5Xl = Radius5Xl;
var Radius6Xl = '20px 20px 20px 20px';
exports.Radius6Xl = Radius6Xl;
var Radius7Xl = '22px 22px 22px 22px';
exports.Radius7Xl = Radius7Xl;
var Radius8Xl = '24px 24px 24px 24px';
exports.Radius8Xl = Radius8Xl;
var RadiusPill = '500px 500px 500px 500px';
exports.RadiusPill = RadiusPill;
var RadiusRound = '50px 50px 50px 50px';
exports.RadiusRound = RadiusRound;
var MotionXs = '0.2s';
exports.MotionXs = MotionXs;
var MotionSm = '0.4s';
exports.MotionSm = MotionSm;
var MotionMd = '0.6s';
exports.MotionMd = MotionMd;
var MotionLg = '0.8s';
exports.MotionLg = MotionLg;
var MotionXl = '1.0s';
exports.MotionXl = MotionXl;
var OpacityXs = '0.050';
exports.OpacityXs = OpacityXs;
var OpacitySm = '0.100';
exports.OpacitySm = OpacitySm;
var OpacityMd = '0.250';
exports.OpacityMd = OpacityMd;
var OpacityLg = '0.500';
exports.OpacityLg = OpacityLg;
var OpacityXl = '0.750';
exports.OpacityXl = OpacityXl;
var Opacity2Xl = '0.900';
exports.Opacity2Xl = Opacity2Xl;
var Opacity3Xl = '0.950';
exports.Opacity3Xl = Opacity3Xl;
var StrokeXs = '1px';
exports.StrokeXs = StrokeXs;
var StrokeSm = '2px';
exports.StrokeSm = StrokeSm;
var StrokeMd = '4px';
exports.StrokeMd = StrokeMd;
var StrokeLg = '8px';
exports.StrokeLg = StrokeLg;
var ShadowXs = '0px 2px 5px rgba(199, 206, 201, 0.16), 0px 0px 1px rgba(165, 174, 167, 0.90)';
exports.ShadowXs = ShadowXs;
var ShadowSm = '0px 12px 12px rgba(0, 0, 0, 0.08), 0px 0px 8px rgba(0, 0, 0, 0.08)';
exports.ShadowSm = ShadowSm;
var ShadowMd = '0px 16px 12px -8px rgba(0, 0, 0, 0.16), 0px 16px 8px -12px rgba(0, 0, 0, 0.12)';
exports.ShadowMd = ShadowMd;
var ShadowLg = '0px 28px 64px rgba(20, 20, 20, 0.16)';
/*
   * Components
*/

exports.ShadowLg = ShadowLg;